import debug from 'debug';
// Using UMD version instead of ES6, @see https://github.com/nolimits4web/Swiper/issues/2237 @4.5.1
// import Swiper from 'swiper/dist/js/swiper.js';
import Swiper from 'swiper/bundle';
import BaseComponent from 'Global/Shared/Components/BaseComponent/BaseComponent';
import Debounce from 'Global/Shared/Components/Debounce/Debounce';
import Sitecore from 'Global/Shared/Components/Sitecore/Sitecore';
import arrowRight2Svg from 'Minetilbud/Shared/Icons/arrow_right_2.svg';
import DataLayer from 'Minetilbud/Shared/Components/GoogleAnalyticsEvents/DataLayer';

const log = debug('InspirationCarousel');
const dataLayer = new DataLayer();
const debounce = new Debounce().debounce;

class InspirationCarousel extends BaseComponent {
	constructor(element) {
		super(element)

		this.scrollEvent = this.scrollHandler.bind(this);
		this.scrollHandler = debounce(this.scrollHandler, 250);
		this.slideChangeEvent = this.slideChangeHandler.bind(this);
		this.slideClickEvent = this.slideClickHandler.bind(this);

		this.initialize();
	}

	eventListeners() {
		document.addEventListener('scroll', this.scrollEvent, true);
		this.element.addEventListener('click', this.slideClickEvent, false);
	}

	/**
	 * @returns {Object} settings [catalogId, customerId]
	 */
	 getSettings() {
		let settings = {};

		try {
			settings = JSON.parse(this.element.getAttribute('data-settings'));
			log('getSettings()', settings);
			this.settings = settings;
		} catch (error) {
			log('getSettings() - error', error);
			settings = null;
		}

		return settings;
	}

	initialize() {
		if (this.getSettings() === null) return;

		this.initDomCache();
		this.eventListeners();

		if (this.isInView() === false) return;

		this.setup();
	}

	isInView() {
		if (Sitecore.isEdit()) return true;
		if (document.body.getAttribute('data-page') === 'frontpage') return true;

		const elementRect = this.element.getBoundingClientRect();

		if ((elementRect.top > 0 || elementRect.bottom > 0) && elementRect.top < window.innerHeight) {
			return true;
		};

		return false;
	}

	logVisibleSlides() {
		for (let i = 0; i < this.carousel.slides.length; i++) {
			if (this.carousel.slides[i].classList.contains('swiper-slide-visible')) {
				const title = this.carousel.slides[i].getAttribute('data-title');
				
				if (this.visibleSlides.indexOf(title) === -1) {
					this.visibleSlides.push(title);

					dataLayer.Set({
						event: 'universe_carousel_view',
						detail: title
					});
				}
			}
		}
	}

	scrollHandler() {
		if (this.element.classList.contains('is-in-view')) return;
		if (this.isInView() === false) return;
		this.setup();
	}

	setup() {
		if (this.element.classList.contains('is-in-view')) return;
		this.element.classList.add('is-in-view');

		this.visibleSlides = [];

		this.element.classList.remove('is-loading');
		this.element.classList.add('swiper-container');
		this.dom.slides.classList.add('swiper-wrapper');

		if (this.dom.slides.children.length === 0 && Sitecore.isEdit()) {
			this.element.classList.add('o-inspiration-carousel--no-slides');
		}

		[...this.dom.slides.children].map(child => {
			child.classList.add('swiper-slide');
		});

		this.swipe();
		this.logVisibleSlides();
	}

	slideChangeHandler() {
		this.logVisibleSlides();
	}

	slideClickHandler(event) {
		const element = event.target.closest('[data-js="inspiration-carousel-slide"]');

		if (element === null) return;

		const title = element.getAttribute('data-title');

		dataLayer.Set({
			event: 'universe_carousel_click',
			detail: title
		});
	}

	swipe() {
		let options = {
			speed: this.settings.speed,
			loop: this.settings.loop,
		}

		if (this.dom.slides.children.length > 1) {
			this.dom.buttonNext.classList.add('o-inspiration-carousel__button-next');
			this.dom.buttonNext.insertAdjacentHTML('beforeend', arrowRight2Svg);

			this.dom.buttonPrev.classList.add('o-inspiration-carousel__button-prev');
			this.dom.buttonPrev.insertAdjacentHTML('beforeend', arrowRight2Svg);

			log('swipe() - settings');

			options = {
				slidesPerView: 'auto',
				spaceBetween: 0,
				slidesOffsetBefore: 5,
				speed: this.settings.speed,
				loop: this.settings.loop,
				navigation: {
					nextEl: '.o-inspiration-carousel__button-next',
					prevEl: '.o-inspiration-carousel__button-prev'
				},
				watchSlidesVisibility: true
			}
		}

		if (this.dom.slides.children.length > 1 && this.settings.autoStart) {
			Object.assign(options, {
				autoplay: {
					delay: this.settings.delay
				}
			});
		}

		this.carousel = new Swiper(this.element, options);
		this.carousel.on('slideChange', this.slideChangeEvent);

		log('setupCarousel() - slides', this.carousel.slides);
	}
}

export default InspirationCarousel;
